
import { gql } from "apollo-angular";




export const GET_USER_FAVOURITES_QUERY = (user_id: number, lang: string)=> gql `{
   favorites (user_id: "${user_id}")
   {
    id
    product {
      id
      brand {
        name: name_${lang}
        description: description_${lang}
      }
      photo
      name: name_${lang}
      price
      discount
      rate
      rateCount
      offers{
      id
      percentage
      product_id
      }
    }
   }
}`;


export const GET_USER_ORDERS_QUERY = (user_id: number, lang: string)=> {


  return gql `{
orders (user_id: "${user_id}") {
    users {
      mobile
    }
    id
    takeway
    rated
    order_status_id
    total
    created
    order_status {
      id
      name: name_${lang}
    }
    billing_address {
      id
      address
      building_number
      floor_number
      apartment_number
      phone
    }
    paymenttype {
      id
      name: name_${lang}
    }
    order_details {
      id
      orderId
      rated
      order_details_options {
        id
        menu_options {
          id
          attributes_options {
            name: name_${lang}
          }
        }
      }
      product {
        id
        name: name_${lang}
        photo
      }
      notes
      amount
      total
    }
    sub_total
    taxes
    delivery_serivce
    voucher_discount

  }

}`
};
